import React, { useState } from "react";
import PropTypes from "prop-types"; // ✅ Import prop-types
import { Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

function TopAlert({ onClose }) {
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
    if (onClose) onClose(); 
  };

  if (!open) return null;

  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "#212121",
        color: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center", 
        padding: "10px 20px",
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 1100,
        height: "40px", // Increased height for better visibility
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
      }}
    >
      <Typography sx={{ fontWeight: "bold", fontSize: 15, textAlign: "center" }}>
        <span style={{ fontWeight: "bold", color: "#FFD700" }}>
          This is a temporary website. For assistance please{" "}
          <u>
            <a href="/contact-us" style={{ color: "white", textDecoration: "none" }}>
              contact
            </a>
          </u>
        </span>
      </Typography>
      <IconButton size="small" onClick={handleClose} sx={{ color: "#FFD700", position: "absolute", right: 10 }}>
        <CloseIcon />
      </IconButton>
    </Box>
  );
}

// ✅ Add PropTypes validation
TopAlert.propTypes = {
  onClose: PropTypes.func.isRequired, // Ensure onClose is a required function
};

export default TopAlert;
